export namespace IDashboard {
  export const Action = 'DashBoard2';

  export interface IState {
    waitingRequest: boolean;
    filters: IFilters;
    dashboards: IDashboardsData;
  }

  export interface IFilters {
    parks: number[];
    tSumType?: number;
  }

  export interface IDashboardsData {
    header: IHeaderData;
    sumByYears: IByYearData[];
    countByYears: IByYearData[];
    occupancyYear: IOccupancyData[];
    occupancyMonth: IOccupancyData[];
    occupancyToday: IOccupancyData[];
  }

  export interface IHeaderData {
    onParkGuests: number;
    onParkNow: number;
    onParkPayment: number;
    onParkWithTarif: number;
    parkFreePlaces: number;
    parkTotalPlaces: number;
    sum: number;
  }

  export interface IByYearData {
    year: number;
    month: number;
    sum?: number;
    count?: number;
  }

  export enum MonthChartType {
    Sum = 'sum',
    Count = 'count',
  }

  export interface IOccupancyData {
    hour: number;
    count: number;
  }

  export enum LocalStorageKeys {
    FilterValues = 'dashboards:filters',
  }
}
